/* eslint-disable max-lines */
/* istanbul ignore file */
import warnEnvelope from 'images/icons/warn_envelope.svg';
import warn from 'images/icons/warn.svg';
import safamIcon from 'images/safam.svg';
import jiraLogo from 'images/logos/jira-logo.svg';
import shortcutLogo from 'images/logos/shortcut-logo.svg';
import azureBoardsLogo from 'images/logos/azure-boards.svg';
import {
  ACCOUNT_TYPES_MAP,
  ACCOUNT_TYPES_NAMES,
  FEATURE_FLAGS_NAMES,
  SettingValues,
  MEDIAN_VALUES,
  BENCHMARK_ORG_SIZE_KEYS,
  SENSORS_MAP
} from '@linearb/linjs-common';

export const TOKEN_VERSION_FOR_BB_GITSTREAM_INTEGRATION = 'v3';

export const LICENSES = {
  FREE: 'free',
  PRO: 'pro',
  ENTERPRISE: 'enterprise'
};

export const MOMENT = {
  UNITS: {
    DAY: 'day',
    YEAR: 'year',
    MONTH: 'month',
    MINUTE: 'minutes',
    SECONDS: 'seconds'
  },
  DIFF: {
    TODAY: 0,
    YESTERDAY: -1
  }
};

export const CONTRIBUTORS_TABS = {
  INDIVIDUALS: 'individuals',
  TEAMS: 'teams'
};

export const PRIVACY_POLICY_LINK = 'https://linearb.io/privacy-policy/';
export const TERMS_LINK = 'https://linearb.io/services-agreement/';
export const ITERATIONS_REGEX_DEFAULT = '^.*$';
export const HOUR_FORMAT = 'h:mm';
export const DATE_FORMAT = 'MMM D, YYYY';
export const DATE_FORMAT_WITH_FULL_DAY = 'MMM DD, YYYY';
export const DATE_AND_TIME_FORMAT = 'MMM D, YYYY, h:mm a';
export const SHORT_DATE_FORMAT = 'MMM D';
export const SHORT_NUMERAL_DATE_FORMAT = 'MM/DD';
export const MONTH_AND_YEAR_FORMAT = 'MMM YYYY';
export const SEARCH_DATE_FORMAT = 'YYYY-MM-DD';
export const SEARCH_TIMEDATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const SEARCH_TIMEDATE_FORMAT_DISPLAY = 'YYYY-MM-DD HH:mm';
export const DEFAULT_DAILY_TIME = '09:00';
export const TIME_PICKER_FORMAT = 'hh:mm a';
export const DB_TIME_FORMAT = 'HH:mm';
export const DAYS_PARAM = 'days';
export const MONTHS_PARAM = 'months';
export const YEARS_PARAM = 'years';
export const DAYS_HOURS_FORMAT = 'd [days,] h [hours]';
export const EMPTY_VALUE = '-';
export const EMPTY_NUMBER = 0;
export const PM_METRICS = 'pm-metrics';
export const CHART_LINE_MARKER =
  'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAIAAAD/gAIDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDA2IDc5LmRhYmFjYmIsIDIwMjEvMDQvMTQtMDA6Mzk6NDQgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCAyMi40IChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjY1REQ3NUY5QzRDNDExRURCRDcxQTFBMjRDMkREMzREIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjY1REQ3NUZBQzRDNDExRURCRDcxQTFBMjRDMkREMzREIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NjVERDc1RjdDNEM0MTFFREJENzFBMUEyNEMyREQzNEQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NjVERDc1RjhDNEM0MTFFREJENzFBMUEyNEMyREQzNEQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4ZXtdaAAAApUlEQVR42uzQMQ0AMAgAsDEpkOBfIhb4eFoJjax+7HwFsmTJkiVLlgJZsmTJkiVLgSxZsmTJkqVAlixZsmTJUiBLlixZsmQpkCVLlixZshTIkiVLlixZCmTJkiVLliwFsmTJkiVLlgJZsmTJkiVLgSxZsmTJkqVAlixZsmTJUiBLlixZsmQpkCVLlixZshTIkiVLlixZCmTJkiVLliwFsmRdGwEGAIz3ATPoMoQFAAAAAElFTkSuQmCC)';
export const HOURS_PARAM = 'hours';
export const COOKIES_KEYS = {
  TOKEN: 'token',
  IS_GDPR: 'is_gdpr' // privacy-policy agreement
};

export const STORAGE_TYPES = {
  LOCAL: 'local',
  SESSION: 'session'
};

export const VIEW_PATH_KEYS = {
  DASHBOARD: 'DASHBOARD',
  TEAM_GOALS: 'TEAM_GOALS',
  CONTRIBUTORS: 'CONTRIBUTORS'
};

export const FETCH_STATUSES = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  FINISHED: 'FINISHED'
};

export const LOCAL_STORAGE_KEYS = {
  ACCOUNT_ID: 'account_id',
  SHOW_IS_THAT_YOUR_TEAM_BAR: 'performedOnboardingAt',
  SELECTED_TEAM_ID: 'selected_team_id',
  LICENSE: 'license',
  CLICKED_ON_TEAM: 'clicked_on_team',
  LAST_VIEW_MAIN_PAGE: 'last_view_main_page',
  SELECTED_BOARD_ID: 'selectedBoardId',
  LAST_PROVIDER_NAME: 'lastProviderName',
  LAST_VIEW_NOTIFICATIONS: teamId => `last_view_notifications_${teamId}`,
  CLOSED_PM_BAR: 'closed_project_management_bar',
  CLOSED_PULSE_BAR: 'closed_pulse_bar',
  CLOSED_SLACK_BAR: 'closed_slack_bar',
  IS_PROCESSING_REPOS: 'is_processing_repos',
  FETCH_REPOS_TIMESTAMP: 'fetch_repos_timestamp',
  LINK_ACCOUNT_TOKEN: 'linkAccountToken',
  SHOW_ONLY_TEAMS_WORK: teamId => `show_only_teams_work_${teamId}`,
  PROJECTS_EXCLUDED_ISSUES: 'projects_excluded_issues',
  PROJECTS_ISSUES_TYPES: 'projects_issues_types',
  PROJECT_DELIVERY_BREAKDOWN_TYPE: 'project_delivery_breakdown_type',
  SSO_LOGIN_EMAIL: 'sso_login_email',
  SSO_SHOW_EMAIL: 'sso_show_email',
  TEST_CONNECTIVITY: 'testConnectivity',
  HIDE_NEW_TAG_PM_CUSTOM_DASHBOARD: 'hide_new_tag_pm_custom_dashboard',
  USER_SAVED_REPOS_TS: 'userSavedReposTimeStamp',
  SYNC_TEAMS_CTA_CONFIG: 'syncTeamsCtaConfig',
  HIDE_EMAIL_PREFERENCES_INFO_MESSAGE: 'hideEmailPreferencesInfoMessage',
  SHOULD_LOG_GIT_CONNECT_SUCCESS: 'shouldLogGitConnectSuccess',
  SHOW_NEW_FEATRUE_ALERT_METRCIS_INSPECTION:
    'show_new_feature_alert_metrics_inspection',
  MOCK_MODE_ALL_TEAMS_GROUP: 'mockModeAllTeamsGroup',
  FORCE_LOGOUT_TIMESTAMP: 'force_logout_timestamp',
  RECENT_FILTER_SET_IDS: 'recent_filter_set_ids',
  DONT_SHOW_FILTER_SET_CTA: 'dont_show_filter_set_cta'
};
export const LOCAL_STORAGE_SELECTED_TEAM_ID_NO_ORG = '_selected_team_id';
export const SESSION_STORAGE_KEYS = /** @type {const } */ ({
  AUTH_FLOW: 'auth_flow',
  AUTH_LEVEL: 'auth_level',
  ORG_ID: 'oid',
  DIRECT_LOGIN: 'direct_login',
  INVITATION_ID: 'invitation_id',
  SELECTED_SPRINT_NAME: 'selectedSprintName',
  HUBSPOT_ID: 'hid',
  REDIRECT_TO: 'redirectTo',
  ORGANIZATION_NAME: 'orgName',
  CONTRIBUTORS_DEFAULT_VIEW: 'contributorsDefaultView',
  SLACK_REDIRECT_TEAM_ID: 'slack_predirect_teamid',
  MSTEAMS_REDIRECT_TEAM_ID: 'msteams_redirect_teamid',
  CLOSED_PEOPLE_FILTER: 'closed_people_filter',
  REF_ACCOUNT_ID: 'refAccountId',
  CREATE_INVITATION_TOKEN: 'createInvitationTkn',
  SELECTED_DASHBOARDS: 'selectedDashboard',
  CUSTOM_DASHBOARD_TIMEFRAME: 'customDashboardTimeframe',
  TEST_FLOW: 'test_flow',
  MODIFY_FF: 'modify_ff',
  METRICS_FILTERS: 'metrics_filters',
  GDPR_CHECKBOX: 'gdpr_checkbox', // privacy-policy checkbox
  REQUEST_INVITATION_TOKEN: 'requestInvitationToken',
  SIGN_UP: 'sign_up',
  REGISTRATION_TOKEN: 'registrationToken',
  PROJECT_PROGRESSION: {
    FILTERS: 'projectProgressionFilters'
  },
  RESOURCE_ALLOCATION: {
    FILTERS: 'resourceAllocationFilters'
  },
  TEAMS: {
    TABLE: {
      EXPANDED_ROWS_STATE: 'teams_table_expanded_rows_state'
    }
  },
  GROUP_DASHBOARD: {
    TABLE: {
      EXPANDED_ROWS_STATE: 'group_dashboard_teams_table_expanded_rows_state'
    }
  },
  SELECTED_PERIOD: 'selectedPeriod',
  UPDATE_GITSTREAM_ON_INTEGRATION_ID: 'update_gitstream_on_integration_id',
  GIT_SCOPE_FILTER: {
    [VIEW_PATH_KEYS.DASHBOARD]: 'git_scope_filter_dashboard',
    [VIEW_PATH_KEYS.TEAM_GOALS]: 'git_scope_filter_team-goals',
    [VIEW_PATH_KEYS.CONTRIBUTORS]: 'git_scope_filter_contributors'
  }
});

export const ignoreOrgKeys = [
  LOCAL_STORAGE_KEYS.ACCOUNT_ID,
  LOCAL_STORAGE_KEYS.LAST_PROVIDER_NAME,
  LOCAL_STORAGE_KEYS.LICENSE,
  LOCAL_STORAGE_KEYS.SSO_LOGIN_EMAIL,
  LOCAL_STORAGE_KEYS.SSO_SHOW_EMAIL,
  LOCAL_STORAGE_KEYS.TEST_CONNECTIVITY,
  SESSION_STORAGE_KEYS.CREATE_INVITATION_TOKEN,
  SESSION_STORAGE_KEYS.DIRECT_LOGIN,
  SESSION_STORAGE_KEYS.GDPR_CHECKBOX,
  SESSION_STORAGE_KEYS.HUBSPOT_ID,
  SESSION_STORAGE_KEYS.MODIFY_FF,
  SESSION_STORAGE_KEYS.ORGANIZATION_NAME,
  SESSION_STORAGE_KEYS.REDIRECT_TO,
  SESSION_STORAGE_KEYS.REQUEST_INVITATION_TOKEN
];

export const MUI_PLACEMENTS = [
  'bottom-end',
  'bottom-start',
  'bottom',
  'left-end',
  'left-start',
  'left',
  'right-end',
  'right-start',
  'right',
  'top-end',
  'top-start',
  'top'
];
export const SENSOR_TYPES = /** @type {const} */ ({
  GIT: 1,
  PM: 2,
  HR: 3,
  COLLABORATION: 4
});
export const GIT_PROVIDERS = {
  AZURE_DEVOPS: 9,
  BITBUCKET_SERVER: 6,
  GITHUB: 3,
  GITLAB: 2,
  BITBUCKET: 1
};

export const COLLABORATION_PROVIDERS = {
  SLACK: 5,
  MSTEAMS: 8
};

export const SECURITY_PROVIDERS = {
  SAML: 10
};

export const COLLABORATION_PROVIDERS_IDS_TO_NAMES = {
  5: 'Slack',
  8: 'Microsoft Teams'
};

export const PM_PROVIDERS = {
  JIRA: 4,
  CLUBHOUSE: 7,
  AZURE_BOARDS: 11
};

export const PULSE_SUPPORTED_PM_SENSOR_IDS = [
  PM_PROVIDERS.JIRA,
  PM_PROVIDERS.CLUBHOUSE
];

export const PROVIDERS_MAP = {
  jira: {
    sensor_id: SENSORS_MAP.JIRA,
    name: 'Jira',
    provider_path: 'jira',
    oauth2_path: 'jira_oauth2',
    entities_path: 'board',
    entities_settings_keys: {
      project: 'projects',
      board: 'boards'
    },
    entities_settings_key: 'boards',
    entity_name: 'board',
    entity_names: {
      board: 'board',
      project: 'project'
    },
    entity_names_plural: {
      board: 'boards',
      project: 'projects'
    },
    entity_name_plural: 'boards',
    logo: jiraLogo,
    metrics_all_teams: 'Jira boards: All boards'
  },
  clubhouse: {
    sensor_id: SENSORS_MAP.CLUBHOUSE,
    name: 'Shortcut',
    provider_path: 'clubhouse',
    entities_path: 'project',
    entities_settings_key: 'projects',
    entities_settings_keys: {
      projects: 'projects',
      teams: 'teams',
      labels: 'labels',
      epics: 'epics'
    },
    entity_names: {
      team: 'team',
      project: 'project'
    },
    entity_names_plural: {
      teams: 'teams',
      project: 'projects'
    },
    entity_name: 'project',
    entity_name_plural: 'projects',
    logo: shortcutLogo,
    metrics_all_teams: ''
  },
  azure_boards: {
    sensor_id: SENSORS_MAP.AZURE_BOARDS,
    name: 'Azure Boards',
    displayName: 'Azure Boards',
    provider_path: 'azure_boards',
    entities_path: 'project',
    entities_settings_key: 'projects',
    entity_name: 'project',
    entity_name_plural: 'projects',
    entity_names: {
      project: 'project'
    },
    logo: azureBoardsLogo,
    entities_settings_keys: {
      projects: 'projects',
      boards: 'boards'
    }
  },
  github: {
    sensor_id: SENSORS_MAP.GITHUB,
    name: 'gitHub',
    displayName: 'GitHub'
  },
  gitlab: {
    sensor_id: SENSORS_MAP.GITLAB,
    name: 'gitlab',
    displayName: 'GitLab'
  },
  bitbucket: {
    sensor_id: SENSORS_MAP.BITBUCKET,
    name: 'bitbucket_workerb',
    displayName: 'Bitbucket'
  },
  bitbucket_server: {
    sensor_id: SENSORS_MAP.BITBUCKET_SERVER,
    name: 'bitbucket_server',
    displayName: 'Bitbucket'
  }
};

export const SHORTCUT_ENTITIES_TYPES = {
  PROJECT: 'project',
  TEAM: 'team',
  LABEL: 'label',
  EPIC: 'epic'
};

export const JIRA_AUTH_STATE = {
  NOT_SET: 'not set',
  EXPECTING_APP_LINK: 'expecting application link',
  EXPECTING_APP_AUTHORIZATION: 'expecting application authorization',
  AUTHORIZED: 'authorized',
  FAILING: 'failing'
};

export const PM_AUTH_STATES = {
  authorized: 'authorized',
  IN_PROGRESS: 'in-progress'
};

export const CONTRIBUTOR_ROLES = {
  CONTRIBUTOR: 'contributor',
  TEAM_LEADER: 'team_leader',
  STAKE_HOLDER: 'stake_holder'
};
export const POSSIBLE_AUTH_ERRORS = payload => ({
  REQUEST_INVITATION: {
    message: `Sorry, we did not recognize the email: ${payload.email}`,
    icon: warnEnvelope
  },
  NOT_REGISTERED: {
    message: `Sorry, we did not recognize the email: ${payload.context.email}`,
    icon: safamIcon
  },
  IS_DELETED: {
    message: 'Sorry, this account has been deleted',
    icon: warn
  },
  UNCONFIRMED_INVITATION: {
    message: 'Please confirm the invitation sent to you by email',
    icon: warnEnvelope
  },
  WRONG_EMAIL_CHECKED: {
    message: `Sorry, we did not recognize an invitation for: ${payload.context.email}`,
    icon: safamIcon
  },
  INVITATION_EXPIRED: {
    message: 'We’re having issues signing you in...',
    icon: warn
  },
  SAML_CONFIGURATION_ERROR: {
    message: 'Sorry, wrong SSO IDP configuration',
    icon: warn
  },
  SAML_WRONG_EMAIL: {
    message: 'Email is not recognized',
    icon: warn
  },
  SSO_LOGIN_ONLY_IS_ALLOWED: {
    message: 'Login is allowed with SSO only, please contact your admin',
    icon: warn
  },
  UNKNOWN: {
    message: 'We’re having issues signing you in...',
    icon: warn
  }
});

export const TABLE_SKELETON_NUMBER_OF_ROWS = 4;
export const AUTH_FLOWS = /** @type {const} */ ({
  SIGN_IN: 'SIGN_IN',
  FROM_JWT: 'FROM_JWT',
  LINK: 'LINK',
  LINK_ACCOUNT: 'LINK_ACCOUNT'
});

export const ONBOARDING_ERRORS = /** @type {const} */ ({
  NO_ORGANIZATIONS: 'NO_ORGANIZATIONS'
});

export const AUTH_ERRORS = /** @type {const} */ ({
  REQUEST_INVITATION: 'REQUEST_INVITATION',
  NOT_REGISTERED: 'NOT_REGISTERED',
  IS_DELETED: 'IS_DELETED',
  UNCONFIRMED_INVITATION: 'UNCONFIRMED_INVITATION',
  WRONG_EMAIL_CHECKED: 'WRONG_EMAIL_CHECKED',
  CROSS_ORG: 'CROSS_ORG',
  MATCHING_CONTRIBUTOR: 'MATCHING_CONTRIBUTOR',
  SSO_LOGIN_ONLY_MATCHING_CONTRIBUTOR: 'SSO_LOGIN_ONLY_MATCHING_CONTRIBUTOR'
});

export const AUTH_LEVEL = {
  INDIVIDUAL: 'individual',
  ORGANIZATION: 'organization'
};

export const DD_LOGS_CONSTS = {
  strayOnBoardings: {
    startedFlow: 'Arrived stray onboarding flow',
    createOrganization: 'Creating organization from stray onboarding flow',
    requestInvitation: 'Requesting invitation from stray onboarding flow'
  },
  force_logout:
    'Login timestamp smaller than force update timestamp, but happen twice',
  datadogEvents: {
    setRumOrganizationFailed: 'setRumOrganization failed - organization illegal'
  },
  used_url_token: 'Used token through url',
  errors: {
    branchesV2: {
      noFilter: 'No filter in branchesV2 payload'
    }
  }
};
export const TRACKING = /** @type {const} */ ({
  EVENTS: {
    CLICK: 'click',
    HOVER: 'hover',
    VISIT: 'visit',
    FILTER: 'filter',
    DASHBOARD_READY: 'dashboard_ready', // User reached dashboard after processing is done
    FINISHED_ONBOARDING: 'finished_onboarding', // User reached the dashboard after onboarding wizard(s)
    DASHBOARD_WITH_DATA: 'dashboard_with_data', // user reached dashboard with non-empty state
    FULL_PULSE_VIEW: 'pulse_view_full', // User reached a full pulse view (not empty state)
    LOGIN: 'login', // User logged in to LinearB
    SIGN_UP_IDENTIFICATION_OK: 'signup-identification-ok', // User signed up to LinearB using onboarding flow v2
    IDENTIFICATION_FAIL: 'identification-fail', // User failed to identify to LinearB using onboarding flow v2
    SIGN_UP_IDENTIFICATION_SWITCH: 'signup-identification-switch', // User clicked on "sign up with different credentials"
    SIGN_UP_COMPLETION_OK: 'signup-completion-ok', // User submitted personal identification form
    INVITATION_LINK_CLICKED: 'invitation_link_clicked',
    CONFIGURED_RESOURCE_ALLOCATION_EMAIL:
      'configured_resource_allocation_email',
    SETUP_WIZARD_CONNECT_GIT_START: 'setup-wizard-connect-git-start',
    SETUP_WIZARD_CONNECT_GIT_OK: 'setup-wizard-connect-git-ok',
    SETUP_WIZARD_CONNECT_GIT_FAIL: 'setup-wizard-connect-git-fail',
    SETUP_WIZARD_SCAN_REPOS_OK: 'setup-wizard-scan-repos-ok',
    SETUP_WIZARD_SCAN_REPOS_FAIL: 'setup-wizard-scan-repos-fail',
    MODAL_OPENED: 'modal_opened',
    GRAPH_POINT_CLICK: 'graph_point_click',
    GRAPH_AREA_SELECT: 'graph_area_select',
    /**  Dora dashboard - user clicked on one of the educational info sections*/
    EDU_SECTION_CLICKED: 'edu-section-clicked',
    USER_PROFILE: {
      EVENT: 'user_profile',
      EVENT_TYPE: {
        WIZARD_PRESENTED: 'wizard_presented',
        ADD_ROLE: 'add_role',
        ADD_SENIORITY: 'add_seniority',
        ADD_INTERESTS: 'add_interests',
        ADD_WORK_HOURS: 'add_work_hours',
        BACK: 'back',
        CLOSE: 'close',
        EDIT_USER_PROFILE: 'edit_user_profile'
      }
    }
  },
  SUB_EVENTS: {
    DISMISS_CONNECT_PM_TOOL: {
      CLICKED: () => ({ event: 'dismiss connect pm tool' }),
      SELECT_ALTERNATIVE_PM_TOOL: pmToolName => ({
        event: 'dismiss selected pm tools',
        pmTool: pmToolName
      })
    }
  },
  PAGES: {
    APP_INIT: 'AppInit',
    DASHBOARD: 'Dashboard',
    METRICS: 'Performance',
    PEOPLE: 'People',
    ACTIVITY: 'Activity',
    AUTOMATION: 'automation-dashboard',
    MARKETPLACE: 'automation-marketplace',
    SETTINGS: 'Settings',
    PULSE: 'Pulse',
    ITERATIONS: 'Iterations',
    OVERDUE: 'Overdue',
    ONBOARDING: 'Onboarding',
    SEND_INVITATION: 'SendInvitation',
    LINK_ACCOUNT: 'LinkAccount',
    PROJECTS: 'Projects',
    UNSUBSCRIBE: 'Unsubscribe',
    RESOURCE_ALLOCATION: 'ResourceAllocation',
    INVESTMENT_PROFILE: 'InvestmentProfile',
    PROJECT_PROGRESSION: 'ProjectProgression',
    PROJECT_PROGRESSION_INSIGHTS_CONFIG: 'ProjectProgressionInsightsConfig',
    FORECAST: 'Forecast',
    EMAIL_PREFERENCES: 'EmailPreferences',
    TEAMS: 'Teams',
    METRICS_INSPECTION: 'MetricsInspection'
  },
  ELEMENT_NAME: {
    STORY_TIMELINE: 'Story Timeline',
    BRANCH_TIMELINE: 'Branch Timeline',
    DELIVERY_ALERT: 'Delivery Alert'
  },
  PAGE_TABS: {
    INTEGRATIONS_NOT_UPDATED_BAR: 'Integration not updated bar',
    REAUTH: 'Reauth',
    CONTRIBUTORS: 'Contributors',
    TEAMS: 'Teams',
    INDIVIDUAL: 'Individual',
    SIGN_IN: 'Sign In',
    SIGN_UP: 'Sign Up',
    YOU_LOOK_FAMILIAR: 'You look familiar',
    GIT_ACCESS_TYPE: 'Git Access Type',
    GIT_SELECT_PROVIDER: 'Git Select Provider',
    SELECT_REPOS: 'Select Repos',
    UNABLE_TO_FIND_REPOS: 'Unable to find repos',
    EXPIRED: 'Session Expired',
    BRANCHES: 'Branches',
    RELEASES: 'Releases',
    INCIDENTS: 'Incidents',
    PRS: 'PRs',
    NOTIFICATIONS: 'Notifications',
    INITIAL_PROCESSING: 'Initial Processing',
    SLACK: 'Slack',
    MSTEAMS: 'MSTeams',
    JIRA: 'Jira',
    REPOS: 'Repositories',
    ISSUES_INVESTMENT: 'Investment',
    ISSUES_VELOCITY: 'Velocity',
    TIME_DISTRIBUTION: 'Time Distribution',
    PULSE: 'Pulse',
    TOPBAR: 'TopBar',
    BOTTOM_BAR: 'BottomBar',
    SHORTCUTS: 'Shortcuts',
    CONFIGURE: 'Configure',
    GIT_INTEGRATIONS: 'Git Integrations',
    NEW_GIT_INTEGRATION: 'New Git Integration',
    EMPTY_STATE: 'Empty State',
    PROFILE_PANEL: 'Profile Panel',
    EDIT_MERGE_USER: 'Edit Merge User',
    TIME_SETTINGS_DIALOG: 'Time Settings Dialog',
    ORG_GENERAL_SETTINGS: 'Org General Settings',
    TEAM_GENERAL_SETTINGS: 'Team General Settings',
    ORG_SLACK: 'Org Slack',
    TEAM_SLACK: 'Team Slack',
    TEAM_MSTEAMS: 'Team MSTeams',
    TEAM_INSIGHTS: 'Team Insights',
    DASHBOARD_NEW: 'Dashboard New',
    DASHBOARD_EDIT: 'Dashboard Edit',
    CUSTOM_DASHBOARD: 'Custom Dashboard',
    MTTR: 'MTTR',
    CFR: 'CFR',
    DASHBOARD_RETRO: 'dashboardRetro',
    PULSE_CTA: 'Pulse CTA',
    AUTOMATION_CTA: 'Automation CTA',
    MARKETPLACE_CTA: 'Marketplace CTA',
    RESOURCE_ALLOCATION_CTA: 'ResourceAllocation CTA',
    INVESTMENT_PROFILE_CTA: 'InvestmentProfile CTA',
    PROJECTS_CTA: 'Projects CTA',
    TEAM_GOALS_CTA: 'Team Goals CTA',
    EMAIL_PREFERENCES: 'Email Preferences',
    PERMISSIONS: 'Permissions',
    CUSTOM_METRICS: 'Custom Metrics',
    PROJECT_PROGRESSION_CTA: 'Project Progression CTA'
  },
  CLICK: {
    EXPORT_METRICS_CSV: 'Export Metrics as CSV',
    SINGLE_CLICK: 'Single Click',
    AREA_SELECT: ' Area Select',
    GOING_TO_GIT_PROVIDER: 'Going to the git provider',
    SETUP_PM_CONNECT_START: 'setup-pm-connect-start',
    SETUP_PM_CONNECT_COMPLETED: 'setup-pm-connect-completed',
    DRILLDOWN: 'Drill down',
    GO_TO_SETTINGS: 'Go to settings',
    REAUTH_MODAL_OPENED: 'reauth modal opened',
    REAUTH_APPROVED: 'reauth approved',
    REAUTH_V2_APPROVED: 'reauth V2 approved',
    DELETE_INTEGRATION: 'Delete integration',
    SAVE: 'Save',
    DISMISS: 'Dismiss',
    CONTINUE: 'Continue',
    RELOAD: 'Reload',
    TERMS: 'Terms',
    POLICY: 'Policy',
    HELP_DOCS: 'Help Docs',
    INDIVIDUALS: 'Individuals',
    EFI: 'Efficiency Health Index',
    METRICS: 'Metrics',
    CONNECT_PM: 'Connect Project Management',
    CONNECT_JIRA: 'Connect Jira',
    CONNECT_CLUBHOUSE: 'Connect Shortcut',
    CONNECT_AZURE_BOARDS: 'Connect Azure Boards',
    CONNECT_BOARD: 'Connect Board',
    CONNECT_PROJECT: 'Connect Project',
    CONNECT_SLACK: 'Connect Slack',
    PREMIUM: 'Premium Request',
    UPGRADE_LOGO: 'Logo Upgrade',
    PAT: 'Personal Access Token',
    OAUTH: 'OAuth',
    SLACK_CONNECT: 'Connect Slack',
    MSTEAMS_CONNECT: `Connect ${
      COLLABORATION_PROVIDERS_IDS_TO_NAMES[COLLABORATION_PROVIDERS.MSTEAMS]
    }`,
    WORK_BREAKDOWN_CONTEXT: 'Work Breakdown Context',
    WORK_BREAKDOWN_TREND: 'Work Breakdown Trend',
    CYCLE_TIME_CONTEXT: 'Cycle Time Context',
    CYCLE_TIME_TREND: 'Cycle Time Trend',
    CYCLE_TIME: 'Cycle Time',
    GIT_REDIRECT: 'Git Redirect',
    SEE_MORE: 'See More',
    RISKY_WORK_SHORTCUT: 'Risky Work Shortcut',
    PULSE_VIEW_SHORTCUT: 'Pulse View Shortcut',
    RETROSPECT_SHORTCUT: 'Retro Shortcut',
    INVITE_USERS_SHORTCUT: 'Invite Users Shortcut',
    DEPLOY_FREQ_TREND: 'Deployment Freq Trend',
    REVIEWS_TREND: 'Reviews Trend',
    CHANGE_JIRA_STATE: 'Change Jira State',
    JIRA_REDIRECT: 'Jira Redirect',
    REPO: 'Repository',
    CHANGE_CHANNEL: 'Change Channel',
    OPTIN: 'Notification Optin',
    OPTOUT: 'Notification Optout',
    ALL_CONTRIBUTORS: 'All Contributors',
    ALL_TEAMS: 'All Teams',
    CONTRIBUTOR_BRANCHES: 'Contributor Branches',
    TEAM_BRANCHES: 'Team Branches',
    ADD_REPOS: 'Add Repos',
    ADD_INTEGRATION: 'Add Integration',
    SELECT_PROVIDER: 'Select Provider',
    CONTINUE_EMPTY_REPOS: 'Continue with Empty Repos',
    CANCEL_EMPTY_REPOS: 'Cancel Empty Repos',
    CHANGE_AUTHORIZATION: 'Change Authorization',
    INVITE_ADMIN: 'Invite your admin',
    TALK_TO_US: 'Talk to us',
    MENU_MERGE_USERS: 'Menu Merge Users',
    MENU_UNMERGE_USERS: 'Menu Unmerge Users',
    MENU_EDIT_USERS: 'Menu Edit Users',
    UNMERGE_USER: 'Unmerge User',
    PRIMARY_CHANGED: 'Primary Changed',
    REMOVED_MERGED: 'Removed User from Merged',
    ADDED_MERGED: 'Added User to Merged',
    UPDATE: 'Update',
    SKIP: 'Skip',
    TIMELINE_PR_GIT_LINK: 'Timeline PR Git Link',
    ALERT_PR_GIT_LINK: 'Alert PR Git Link',
    UNMATCHED_BRANCHES: 'Unmatched Branches',
    UNMATCHED_PR: 'Unmatched PR',
    PREDEFINED_WIP: 'Predefined WIP',
    PREDEFINED_DONE: 'Predefined Done',
    PREDEFINED_CARRYOVER: 'Predefined Carryover',
    PREDEFINED_HIGH_RISK: 'Predefined High Risk Work',
    PREDEFINED_HIGH_REWORK: 'Predefined High Rework Rate',
    PREDEFINED_UPDATED: 'Predefined Updated',
    PREDEFINED_MERGED: 'Predefined Merged',
    PREDEFINED_LIGHTNING_PRS: 'Predefined Lightning PRs',
    PREDEFINED_HIGH_INTERACTION: 'Predefined High Interaction',
    PREDEFINED_LONG_LIVING: 'Predefined Long Living',
    PREDEFINED_REVIEW_REQUEST_HANGING: 'Predefined Review Request Hanging',
    PREDEFINED_MERGED_WO_REVIEW: 'Predefined Merged w/o Review',
    EDIT_NOTIFICATION: 'Edit notification',
    EDIT_NOTIFICATIONS: 'Edit Notifications',
    EDIT_NOTIFICATIONS_SETTINGS: 'Edit Notifications Settings',
    LEARN_MORE: 'Learn More',
    RESTORE_DEFAULTS: 'Restore Defaults',
    SLACK_OPT_IN: 'Slack Opt In',
    SLACK_OPT_OUT: 'Slack Opt Out',
    TURN_ON_NOTIFICATIONS: 'Turn On Notifications',
    TURN_OFF_NOTIFICATIONS: 'Turn Off Notifications',
    UPGRADE_SLACK: 'Upgrade Slack',
    FIX_SLACK: 'Fix Slack',
    STRAY_CREATE_NEW_ORG: 'strayCreateNewOrg',
    STRAY_ORG_SHOW_WARNING: 'strayOrgShowWarning',
    STRAY_ORG_CREATE_NEW_ORG: 'strayOrgCreateNewOrg',
    STRAY_ORG_CREATE_NEW_ORG_CONFIRM: 'strayOrgCreateNewOrgConfirm',
    STRAY_REQUEST_INVITATION: 'strayRequestInvitation',
    INVITATION_SENT: 'invitationSent',
    NEW_CUSTOM_DASHBOARD: 'New Custom Dashboard',
    EDIT_DASHBOARD: 'Edit Dashboard',
    DELETE_DASHBOARD: 'Delete Dashboard',
    ADD_METRIC: 'Add Metric',
    DASHBOARD_SAVE: 'Dashboard Save',
    EDIT_METRIC_GRAPH: 'Edit Metric Graph',
    METRICS_ADDED: 'Metrics Added',
    METRIC_DELETED: 'Metric Deleted',
    DASHBOARD_SAVED_AS: 'Dashboard Saved as',
    UPGRADE_FROM_CUSTOM_DASHBOARD: 'Upgrade from custom dashboards',
    DOWNLOAD_AS_PNG: 'Download as PNG',
    EDIT_REPO_LIST: 'Edit Repo List',
    ADD_THE_NEW_REPO: 'Add the new Repo',
    MARK_AS_READ: 'Mark as Read',
    MARK_ALL_AS_READ: 'Mark all as Read',
    DELETE_MESSAGE: 'Delete Message',
    PROJECT_EXTENDED_VIEW: 'project extended view',
    PROJECT_ITERATION_TOOLTIP_OPENED: 'project iteration tooltip opened',
    CREATE_PROJECT: 'Create project',
    EDIT_PROJECT: 'Edit project',
    DELETE_PROJECT: 'Delete project',
    ADD_PROJECT_CONFIG_FILTER: 'Add project config filter',
    SELECT_PROJECT_CONFIG_FILTER: 'Select project config filter',
    TEAM_DASHBOARD_WIDGET_ADDED: 'Team dashboard Widget added',
    TEAM_DASHBOARD_WIDGET_REMOVED: 'Team dashboard Widget removed',
    CREATE_API_TOKEN: 'Create API token',
    REVOKE_API_TOKEN: 'Revoke API token',
    VIEW_METRICS_BENCHMARKS: 'View metrics benchmarks',
    NEW_PULSE_LOAD_PREVIOUS_ITERATIONS: 'Load previous iterations',
    NEW_PULSE_ITERATION_SELECTION: 'New pulse iteration selection',
    ADD_PROJECT_TO_FAVORITES: 'Add project to favorites',
    FAVORITE_PROJECTS_TAB: 'Favorites tab',
    PDT_PIE_DELIVERY_TYPE_SELECT: 'PDT pie delivery type select',
    PDT_ISSUES_TABLE_ROW_CLICK: 'PDT issues table row click',
    PDT_ISSUES_TABLE_SORT_CLICK: 'PDT issues table sort click',
    PDT_ISSUES_TABLE_DELIVERY_TYPE_SELECT:
      'PDT issues table delivery type select',
    // TEAMS AND GROUP
    TEAMS: 'Teams',
    OPEN_TEAM: 'Open Team',
    EDIT_TEAM: 'Edit Team',
    CONFIRM_TEAM: 'Confirm Team',
    ADD_TEAM: 'Add Team',
    DELETE_TEAM: 'Delete Team',
    CONNECT_TEAM: 'Connect Team',
    OPEN_ADD_TEAM: 'Open Add Team',
    CREATE_TEAM: 'Create Team',
    CREATE_GROUP: 'Create Group',
    OPEN_ADD_GROUP: 'Open Add Group',
    UPDATE_GROUP: 'Update Group',
    REMOVE_CHILDREN_FROM_GROUP: 'Remove Children From Group',
    DELETE_GROUP: 'Delete Group',
    SET_GROUP_AS_ROOT: 'Set Group As Root',
    REMOVE_GROUP_AS_ROOT: 'Remove Group As Root',
    FILTERS_BAR: {
      APPLY_FILTER: 'apply_filter',
      FILTER_SET: {
        MENU: {
          OPEN: 'open filter set dropdown menu',
          CLICK: {
            SAVE: 'filter set menu - save',
            MANAGE: 'filter set menu - manage',
            CLEAR: 'filter set menu - clear'
          }
        },
        CRUD: {
          DELETE: 'delete filter set',
          EDIT: 'edit filter set',
          CREATE: 'create filter set'
        },
        SELECT: 'select filter set',
        NAVIGATION: 'filter set navigation',
        APPLY_FILTERS_CTA: {
          PROCEED_TO_SAVE: 'Apply Filters - Proceed to Save',
          APPLY_WITHOUT_SAVING: 'Apply Filters - Apply Without Saving'
        }
      }
    },
    ITERATION_SUMMARY: {
      OPEN: 'open iteration summary',
      CLOSE: 'close iteration summary insight',
      LINK: 'link iteration summary',
      FEEDBACK: 'feedback iteration summary',
      FEEDBACK_TYPES: {
        LIKE: 'like',
        DISLIKE: 'dislike'
      },
      FEEDBACK_SECTIONS: {
        ACCOMPLISHMENTS: 'accomplishments'
      },
      COPY_LINK: 'copy link iteration summary',
      COPY_MARKDOWN: 'copy markdown iteration summary'
    },
    // END OF TEAMS AND GROUP
    RESOURCE_ALLOCATION: {
      SETTINGS: {
        CUSTOM_FIELDS: 'Settings-CustomFields'
      },
      ALLOCATION_OVER_TIME_CHART: {
        DROPDOWN: 'AllocationOverTimeChart-Dropdown',
        TOOLTIP: 'AllocationOverTimeChart-Tooltip'
      },
      FTE_ALLOCATION_CHART: {
        DROPDOWN: 'FteAllocationChart-Dropdown'
      },
      AGGREGATED_TABLE: {
        RESOURCE_TYPE_FILTER: 'AggregatedTable-ResourceTypeFilter',
        EXPORT_CSV: 'AggregatedTable-ExportCSV'
      }
    },
    INVESTMENT_PROFILE: {
      CONFIG: {
        SAVE: 'SaveInvestmentProfileSettings'
      },
      VIEW_ISSUES: 'View Issues'
    },
    PROJECT_PROGRESSION: {
      INSIGHTS: {
        CONFIG: {
          SAVE: 'saveInsightsConfig'
        },
        ON_SELECT_INSIGHT: 'insights_on_select_insight'
      },
      PROGRESSION_TABLE: {
        FILTERS: {
          BY_STATUS: 'progression_table_filter_by_status',
          SEARCH_INPUT: 'progression_table_search'
        },
        LINK_TO_PROVIDER_CELL: 'progression_table_link_to_provider_cell'
      }
    },
    FORECAST: {
      COLUMN_CHART: {
        DISTRIBUTION: 'Distribution',
        PROBABILITY: 'Probability',
        TOOLTIP: 'Column chart tooltip'
      },
      ISSUES_STATES: 'issues states'
    },
    TEAM_SPACE: {
      HEADER: {
        SELECT_TAB: 'select tab',
        SELECT_TEAM: 'select team',
        SELECT_ITERATION: 'select iteration',
        SELECT_TREND_DURATION: 'select trend duration',
        VIEW_ITERATION_ACTIVITY: 'view iteration activity'
      }
    },
    RBAC: {
      SETTINGS: {
        DROPDOWN: {
          USER_TEAMS: 'RBAC-User-Teams',
          SELECT_USER_TEAMS_SCOPE: 'RBAC-Select-User-Teams-Scope'
        },
        SAVE_INVITATION: 'Rbac-Save-Invitation',
        INVITE_USER: 'Rbac-Invite-User',
        SAVE_USER_TEAMS_SCOPE: 'RBAC-Save-User-Teams-Scope',
        EDIT_USER_PERMISSIONS: 'Rbac-Edit-User-Permissions'
      }
    },
    CHECK_GIT_STREAM_BUTTON: 'Check_gitStream_Button',
    BOOK_A_DEMO: 'Book a demo',
    CTA_IMAGE_POINTS: 'CTA image points',
    ADD_TO_MAILING_LIST: 'Add to mailing list',
    TOGGLE_RESOURCE_ALLOCATION_EMAIL: 'Toggle resource allocation email',
    RESUBSCRIBE: 'Resubscribe',
    UNSUBSCRIBE: 'Unsubscribe',
    VIEW_IN_ACTIVITY: 'View in activity',
    COPY_LINK: 'Copy Link'
  },
  FILTER: {
    TEAM: 'Team',
    GROUP: 'Group',
    REPO: 'Repository',
    SERVICE: 'Service',
    LABELS: 'Labels',
    TIMEFRAME: 'Timeframe',
    CONTRIBUTOR: 'Contributor',
    RATE: 'Rate',
    JIRA_STATE_CHANGED: 'Jira State Changed',
    ISSUE_STATE: 'Issue State',
    ISSUE_TYPE: 'Issue Type',
    LABEL: 'Label',
    CUSTOM_FIELD: 'Custom Field',
    SEARCH: 'Search',
    PROJECT_TIME: 'Project Time',
    PROJECT_FILTER_CHART: 'Project Filter Chart',
    PROJECT_FILTER_BY_DELIVERY_TYPE: 'Project Filter by Delivery type',
    PROJECT_FILTER_ESTIMATIONS: 'Project Filter Estimations'
  },
  SOURCE: {
    ADMIN_INVITE: 'Admin Invite'
  },
  HOVER: {
    MOVE_METRIC: 'Move Metric',
    PEOPLE_EFFORT_OVER_TIME: 'People Effort Over Time',
    ACTIVE_PEOPLE: 'Active People',
    INVESTMENT_PROFILE: 'Investment Profile',
    EXECUTION: 'Execution',
    HELP_ME_IMPROVE_GIT_STREAM_CTA: 'Help_Me_Improve_gitStream_CTA',
    ITERATION_SUMMARY: {
      VIEW_BUTTON: 'view iteration summary hover',
      SHARE_BUTTON: 'share iteration summary hover'
    }
  },
  ACCESS: {
    PRIVATE: 'Private',
    PUBLIC: 'Public'
  }
});
export const ARTICLE_IDS = {
  CONNECT_SLACK: 'vnepout2w4',
  CYCLE_TIME: 'v9pckvmkbj',
  POINT_IN_HISTORY: 'kv6i92sezl',
  CONNECT_JIRA_BOARD: '2mc7kl8sot',
  ONBOARDING_TROUBLESHOOT: 'jnnhljaqyu',
  INITIAL_TEAM: 'i6z0gcvril',
  PULSE_NAMING: '80cg9o0dhu',
  WIP: 'a93cjbshlp',
  DONE_IN_ITERATION: 'fra4z93dex',
  CARRYOVER: 's6avo913wv',
  HIGH_RISK: '7mjk0k1rgm',
  HIGH_REWROK: 'h1kr5vx2fd',
  WORK_BREAKDOWN: 'tpxx3m8cwb',
  THROUGHPUT_METRICS: 'tpmxyz5ei7',
  REVIEW_DEPTH: 'sf643osbmq',
  MERGED_WITHOUT_REVIEW: 's0jjewxoh9',
  PR_SIZE: 'x1620txj8m',
  BRANCH_STATE: '83dyr15yme',
  PR_STATE: 'oknqh6k7cn',
  CODE_CHANGES_RATE: 'fypuctwrek',
  DEPLOYMENT_FREQ: 'gm1zmtps8p',
  PR_OPEN_RATE: 'l0irnv33z7',
  UPDATED_IN_ITERATION: '3a56ox8pyl',
  MERGED_IN_ITERATION: 'x4448wfnyx',
  LIGHTNING_PR: '69f29yawrr',
  HIGH_INT_PR: 'zzjmzqx1ku',
  LONG_LIVING_PR: 'gvf7nqpyb3',
  REVIEW_REQUEST_HANGING: 'bg6c46ds1y',
  WHO_IS_ACTIVE: 'g4czwado46',
  NOTIFICATION_TYPES: '16zfs7qnli',
  CONNECT_PM: 'p0a1a6m12x',
  ISSUES_DONE: '',
  ISSUES_DONE_STORY_POINTS: '',
  ISSUES_PLANNED: '',
  ISSUES_PLANNED_STORY_POINTS: '',
  PM_MTTR: 'y6ul0o0vz0',
  PM_CFR: 'bqkxf4rjom',
  PROJECTS: 'vrybjfmbto',
  RESOURCE_ALLOCATION: 'xrmcww51ht',
  INVESTMENT_CARVING: 'oaf32occ9w',
  SET_JIRA_BOARD_PER_TEAM: 'lgxqav9eo9',
  CREATE_AND_EDIT_PROJECT: '8j9p5l4cl4',
  CONNECT_JIRA_SERVER: 'k820yuv9og'
};
export const WORK_DAYS_OPTIONS = [
  { value: '2-6', displayValue: 'Monday to Friday', daysOff: [7, 1] },
  { value: '1-5', displayValue: 'Sunday to Thursday', daysOff: [6, 7] },
  { value: '1-6', displayValue: 'Sunday to Friday', daysOff: [7] }
];

export const WORK_DAYS = [
  'Monday to Friday',
  'Sunday to Thursday',
  'Sunday to Friday'
];

export const METRICS_CALCULATION_STRATEGY = [
  { value: 'avg', displayValue: 'Average' },
  {
    value: MEDIAN_VALUES.p50,
    displayValue: 'Median (50% of PRs lower, 50% higher)'
  },
  {
    value: MEDIAN_VALUES.p75,
    displayValue: '75th Percentile (75% of PRs lower, 25% higher)'
  },
  {
    value: MEDIAN_VALUES.p90,
    displayValue: '90th Percentile (90% of PRs lower, 10% higher)'
  }
];

export const DAILY_TIME_HOUR_OPTIONS = [
  { value: '12', displayValue: '12' },
  { value: '01', displayValue: '01' },
  { value: '02', displayValue: '02' },
  { value: '03', displayValue: '03' },
  { value: '04', displayValue: '04' },
  { value: '05', displayValue: '05' },
  { value: '06', displayValue: '06' },
  { value: '07', displayValue: '07' },
  { value: '08', displayValue: '08' },
  { value: '09', displayValue: '09' },
  { value: '10', displayValue: '10' },
  { value: '11', displayValue: '11' }
];
export const DAILY_TIME_MINUTE_OPTIONS = [
  { value: '00', displayValue: '00' },
  { value: '05', displayValue: '05' },
  { value: '10', displayValue: '10' },
  { value: '15', displayValue: '15' },
  { value: '20', displayValue: '20' },
  { value: '25', displayValue: '25' },
  { value: '30', displayValue: '30' },
  { value: '35', displayValue: '35' },
  { value: '40', displayValue: '40' },
  { value: '45', displayValue: '45' },
  { value: '50', displayValue: '50' },
  { value: '55', displayValue: '55' }
];
export const DAILY_TIME_PERIOD_OPTIONS = [
  { value: 'am', displayValue: 'AM' },
  { value: 'pm', displayValue: 'PM' }
];
export const prStateToIconMap = {
  release: { name: 'Release', color: 'malachite' },
  commit: { name: 'Commit', color: 'nepal' },
  'pr-initiated': { name: 'PrInitiated', color: 'nepal' },
  'pr-merged': { name: 'PrMerged', color: 'nepal' },
  'review-commented': { name: 'ReviewCommented', color: 'nepal' },
  'review-approved': { name: 'ReviewApproved', color: 'malachite' },
  'review-changes_requested': {
    name: 'ReviewChangesRequested',
    color: 'orangePeel'
  },
  'pr-closed': { name: 'PrClosed', color: 'torchRed' }
};
export const METRICS = {
  BUG_COLOR: 'orangePeel',
  BUG_STATE: 'Bug',
  TIME_FRAME_FILTER_OPTIONS: [3, 5, 8, 10]
};

export const LOADING_STATUS = {
  INIT: 'init',
  COMPLETED: 'completed'
};

export const IDENTITY_PROVIDERS = {
  GITHUB: 'github',
  BITBUCKET: 'bitbucket',
  BITBUCKET_SERVER: 'bitbucket_server',
  SLACK: 'slack',
  GITLAB: 'gitlab',
  GOOGLE: 'google',
  MSTEAMS: 'azure_ad_oauth2',
  MSTEAMS_V2: 'azure_ad_oauth2_v2',
  AZURE_DEVOPS: 'azure_devops',
  SAML: 'saml'
};

export const REAUTHORIZATION_STATUS = {
  VALID: 'true',
  NOT_VALID: 'false'
};

export const validationStatusToMessageMap = {
  VALID: 'VALID',
  INVALID: 'The token provided is invalid',
  ERROR: 'We were not able to validate your access token',
  MISSING_SCOPES: 'The following access scopes are missing:',
  EXPIRED: 'Access token is expired',
  NOT_RELATED_TO_ORG: 'The user is not related to any organization'
};

export const mapPersonalAccessTokenErrorReason = {
  NO_ADMIN:
    '- the personal access token must be created with the required scopes by organization Owners or Project Collection Administrators',
  NO_PROJECTS: '- no projects found'
};

export const ITERATION_TYPE = {
  CUSTOM: 'custom',
  IMPORT: 'import'
};

export const SETTING_DEFINITION_LEVELS = {
  organization: 'organization',
  team: 'team'
};

export const TIMELINE_TYPES = {
  ACTIVITY: 'daily_contribution',
  RELEASE: 'release',
  MERGE: 'merge',
  PR: 'pr.open'
};

export const TEAM_TYPES = {
  STANDARD: 'standard',
  TEAM: 'team',
  GROUP: 'group',
  SYNCED: 'synced',
  ALL_CONTRIBUTORS: 'all_contributors',
  ALL_TEAMS: 'all_teams'
};

export const SETTINGS_NAMESPACES = {
  FEATURE_FLAG: 'featureFlags'
};

export const ALLOWED_EMAILS_DOMAINS_MODIFY_FF_QS = ['linearb.io'];

export const SETTING_NAMES = {
  MS_TEAMS_APP_CLIENT_ID: 'msTeamsAppClientId',
  RELEASE_STAGES: 'releaseStages',
  RELEASES_STRATEGY: SettingValues.RELEASES_STRATEGY,
  INCIDENTS_STRATEGY: SettingValues.INCIDENTS_STRATEGY,
  TEAM_MSTEAMS_CHANNEL: 'teamMsTeamsChannel',
  TEAM_SLACK_CHANNEL: 'teamSlackChannel',
  SAML_SSO: 'ssoSettings',
  METRICS_BENCHMARKS_ENABLED: 'metricsBenchmarksEnabled',
  SHOW_PERSONAL_INFORMATION: 'showPersonalInformation',
  HIDE_NON_WORKING_DAY: 'hideNonWorkingDays'
};

export const ITERATION_SORTING_BY = {
  ORDER: ['end_date', 'start_date', 'name', 'state'],
  DIRECTION: ['desc', 'desc', 'asc', 'asc']
};

export const REPOSITORY_OWNER_TYPES = {
  ORG: 'Organization',
  USER: 'User'
};

export const SUPPORTED_CHAT_TOOLS = /** @type {const} */ ({
  SLACK: 'Slack',
  MSTEAMS: 'Microsoft Teams'
});

export const DASHBOARD_INTERNAL_TYPES = {
  TEAM_GOALS: 'teamGoals',
  CUSTOM_PM_METRICS: 'customPmMetrics'
};

export const DASHBOARD_NAMES = {
  TEAM_GOALS: 'Team Goals',
  CUSTOM_METRICS: 'Custom Metrics'
};

export const PROVIDER_NAMES = {
  github: 'github',
  gitlab: 'gitlab',
  bitbucket: 'bitbucket',
  azure_devops: 'azure_devops',
  bitbucket_server: 'bitbucket_server'
};

export const PAT_ONLY_PROVIDERS = {
  bitbucket_server: 'bitbucket_server'
};

export const PROVIDERS_FETCH_LARGE_REPOS_FF = {
  [IDENTITY_PROVIDERS.GITHUB]: FEATURE_FLAGS_NAMES.githubFetchLargeRepos,
  [IDENTITY_PROVIDERS.AZURE_DEVOPS]: FEATURE_FLAGS_NAMES.azureFetchLargeRepos,
  [IDENTITY_PROVIDERS.GITLAB]: FEATURE_FLAGS_NAMES.gitlabFetchLargeRepos,
  [IDENTITY_PROVIDERS.BITBUCKET]: FEATURE_FLAGS_NAMES.bitbucketFetchLargeRepos
};

export const REPOSITORIES_STATE = {
  INACTIVE: 'inactive',
  ACTIVE: 'active',
  FAILING: 'failing'
};

export const BACKFILL_STATE = {
  INITIATED: 'initiated',
  STARTED: 'started',
  COMPLETED: 'completed',
  FAILED: 'failed',
  NOT_COMPLETED: 'not_completed'
};

// MODIFY ENVS CONSTS
export const SET_BRANCH = 'set_branch';
export const SET_TAG = 'set_tag';
export const SET_MFA_BRANCH = 'set_mfa_branch';
export const SET_MFA_TAG = 'set_mfa_tag';
export const MFA_ARTIFACTS_COOKIE = 'mfa_artifacts';
export const ARTIFACT_COOKIE_NAME = 'origin';
export const BRANCH_PREFIX = '/branches/';
export const TAG_PREFIX = '/tags/';

export const REPOSITORY_ERRORS = {
  NO_PRIVATE_REPOS: 'no_private_repos',
  NO_ACTIVE_REPOS: 'no_active_repos'
};

export const ALL_ACCOUNTS_TYPES_OPTIONS = [
  {
    value: ACCOUNT_TYPES_MAP.Viewer,
    displayValue: ACCOUNT_TYPES_NAMES[ACCOUNT_TYPES_MAP.Viewer]
  },
  {
    value: ACCOUNT_TYPES_MAP.Editor,
    displayValue: ACCOUNT_TYPES_NAMES[ACCOUNT_TYPES_MAP.Editor]
  },
  {
    value: ACCOUNT_TYPES_MAP.Primary,
    displayValue: ACCOUNT_TYPES_NAMES[ACCOUNT_TYPES_MAP.Primary]
  }
];

export const FEDERATED_APP_SETTINGS = /** @type {const} */ ({
  AUTOMATIONS: {
    scope: 'automations',
    module: './App',
    localUrl: 'http://localhost:4000',
    artifactPath: 'automations-mfa'
  },
  DEV_COACHING: {
    scope: 'dev_coaching',
    module: './App',
    localUrl: 'http://localhost:4001',
    artifactPath: 'dev-coaching-mfa'
  },
  PRODUCTIVITY: {
    scope: 'metrics',
    module: './ProductivityGain',
    localUrl: 'http://localhost:4002',
    artifactPath: 'metrics-mfa'
  },
  SURVEYS: {
    scope: 'surveys',
    module: './App',
    localUrl: 'http://localhost:4018',
    artifactPath: 'surveys-mfa'
  }
});
// TO DO: when BE is ready with the new all teams this should be deleted
export const ALL_TEAMS_NEW_TEMP = {
  id: 888888888888,
  organization_id: 93672499,
  type: TEAM_TYPES.ALL_TEAMS,
  name: 'ALL TEAMS NEW',
  initials: 'ALL',
  color: '#61656C',
  extra: null,
  created_at: '2023-12-31T12:59:51.103Z',
  updated_at: null,
  deleted_at: null,
  established_at: '2023-09-30T12:59:51.000Z',
  project_id: 232570562,
  parent_id: null,
  provider_id: null,
  contributors: [],
  contributor_ids: []
};

export const TOO_LONG_ITERATION = 90;

export const URL_CONTEXTS = {
  TEAM: 'team',
  ORGANIZATION: 'org',
  TEAM_ITERATION: 'team_iteration'
};

export const BENCHMARK_ORG_SIZE = [
  {
    value: BENCHMARK_ORG_SIZE_KEYS.all,
    displayValue: 'Industry Wide (Default)'
  },
  {
    value: BENCHMARK_ORG_SIZE_KEYS.startup,
    displayValue: (
      <>
        Calculated for&nbsp;<b>Startups</b>
      </>
    )
  },
  {
    value: BENCHMARK_ORG_SIZE_KEYS.scale_up,
    displayValue: (
      <>
        Calculated for&nbsp;<b>Scale Ups</b>
      </>
    )
  },
  {
    value: BENCHMARK_ORG_SIZE_KEYS.enterprise,
    displayValue: (
      <>
        Calculated for&nbsp;<b>Enterprises</b>
      </>
    )
  }
];

export const SURVEY_PATH_PATTERN = 'surveys/execute';
